var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C7.58073 4 4 7.58073 4 12C4 15.5339 6.29167 18.5339 9.47135 19.5911C9.8724 19.6641 10.0182 19.4193 10.0182 19.2057C10.0182 19.0156 10.0104 18.513 10.0078 17.8464C7.78125 18.3281 7.3125 16.7734 7.3125 16.7734C6.94792 15.849 6.42448 15.6016 6.42448 15.6016C5.69792 15.1068 6.47917 15.1172 6.47917 15.1172C7.28125 15.1745 7.70313 15.9401 7.70313 15.9401C8.41667 17.1641 9.57552 16.8099 10.0312 16.6068C10.1042 16.0885 10.3125 15.737 10.5391 15.5365C8.76302 15.3359 6.89583 14.6484 6.89583 11.5833C6.89583 10.7083 7.20833 9.99479 7.71875 9.4349C7.63802 9.23438 7.36198 8.41927 7.79688 7.31771C7.79688 7.31771 8.46875 7.10417 9.9974 8.13802C10.6354 7.96094 11.3203 7.8724 12 7.86979C12.6797 7.8724 13.3646 7.96094 14.0026 8.13802C15.5313 7.10417 16.2005 7.31771 16.2005 7.31771C16.638 8.41927 16.3646 9.23438 16.2812 9.4349C16.7943 9.99479 17.1016 10.7083 17.1016 11.5833C17.1016 14.6562 15.2318 15.3307 13.4505 15.5312C13.737 15.776 13.9922 16.2656 13.9922 17.0104C13.9922 18.0807 13.9844 18.9427 13.9844 19.2057C13.9844 19.4193 14.1276 19.6693 14.5339 19.5911C17.7109 18.5312 20 15.5339 20 12C20 7.58073 16.4193 4 12 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitIcon);
export default __webpack_public_path__ + "static/media/git-icon.69d42f31.svg";
export { ForwardRef as ReactComponent };